import React, { useState , useEffect} from 'react';
import ReactApexChart from 'react-apexcharts';
import Select from 'react-select';

const ErrorAndTakenBy = ({ allIteration }) => {

    const [iterationList, setIterationList] = useState([]);
    const [playTime , setPlayTime] = useState([]);
    const [errorOccurred , setErrorOccurred] = useState([]);
    const [defaultValue ,  setDefaultValue] = useState({ value: 'UnGuided', label: 'Assessment', type:"UNGUIDED" });
    const [options , setOptions] = useState([{ value: 'Guided', label: 'Training' , type:"GUIDED" }, { value: 'UnGuided', label: 'Assessment' , type:"UNGUIDED" }])

    const [chartData, setChartData] = useState({
        series: [
            {
                name: 'Played Time',
                type: 'column',
                data: []
            },
            {
                name: 'Errors Occurred',
                type: 'line',
                data: []
            }
        ],
        options: {
            chart: {
                height: 350,
                type: 'line',
                toolbar: {
                    show: false
                }
            },
            stroke: {
                width: [0, 4]
            },
            dataLabels: {
                enabled: true,
                enabledOnSeries: [1]
            },
            xaxis: {
                categories: []
            },
            yaxis: [
                {
                    title: {
                        text: 'Played Time'
                    }
                },
                {
                    opposite: true,
                    title: {
                        text: 'Errors Occurred'
                    }
                }
            ],
            toolbar: {
                show: false
            }
        }
    });

    const setUnGuidedGraphChart = () =>{
        const unGuidedFilter = allIteration.filter((e) => e.mode != "GUIDED");
        const a = (unGuidedFilter.map(e => e.errors)).reverse();
        const b = (unGuidedFilter.map(e => e.time.inSeconds)).reverse();
        // const a = unGuidedFilter.map(e => e.errors);
        // const b = unGuidedFilter.map(e => e.time.inSeconds);
        const c = unGuidedFilter.map((e ,i ) => `Iteration ${i+1}`);

        setChartData({
            series: [
                {
                    name: 'Played Time',
                    type: 'column',
                    data: [...b]
                },
                {
                    name: 'Errors Occurred',
                    type: 'line',
                    data: [...a]
                }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    width: [0, 4]
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                xaxis: {
                    categories: [...c]
                },
                yaxis: [
                    {
                        title: {
                            text: 'Played Time'
                        }
                    },
                    {
                        opposite: true,
                        title: {
                            text: 'Errors Occurred'
                        }
                    }
                ],
                toolbar: {
                    show: false
                }
            }
        });
    }

     const setGuidedGraphChart = () =>{
        const guidedFilter = allIteration.filter((e) => e.mode != "UNGUIDED");
        // const a = guidedFilter.map(e => e.errors).reverse();
        const b = guidedFilter.map(e => e.time.inSeconds).reverse();
        const c = guidedFilter.map((e ,i ) => `Iteration ${i+1}`);
        setChartData({
            series: [
                {
                    name: 'Played Time',
                    type: 'column',
                    data: [...b]
                },
                // {
                //     name: 'Errors Occurred',
                //     type: 'line',
                //     data: [...a]
                // }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    width: [0, 4]
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                xaxis: {
                    categories: [...c]
                },
                yaxis: [
                    {
                        title: {
                            text: 'Played Time(in sec)'
                        }
                    },
                    // {
                    //     opposite: true,
                    //     title: {
                    //         text: 'Errors Occurred'
                    //     }
                    // }
                ],
                toolbar: {
                    show: false
                }
            }
        });
    }

    useEffect(()=>{
        if(allIteration?.length){
            setUnGuidedGraphChart();
        }
    },[allIteration]);


    const handleChange = (selected) => {
        setDefaultValue(selected);
        if( selected.type == "GUIDED" ){
            setGuidedGraphChart();
        }else if(selected.type == "UNGUIDED"){
            setUnGuidedGraphChart();
        }
    };


    return (
        <div className="card">
            <div className="card-body">
                <div className='d-flex justify-content-between'>
                    <h5># Errors And Time Taken (By Iteration)</h5>
                    <Select options={options} value={defaultValue} onChange={handleChange} placeholder="Select Mode" />
                </div>
                <div id="chart">
                    <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="line"
                        height={350}
                    />
                </div>
            </div>
        </div>
    );
};

export default ErrorAndTakenBy;
